import style from './index.module.scss';
import { useI18n } from '@lib/i18n';

import {
	CDN_URL,
	FOOTER_MENU_ITEMS,
	FOOTER_MENU_ITEMS_SECONDARY,
	FOOTER_ADDRESS,
	LABEL_POWERED_BY,
} from '@lib/constants';

export default function SplitFooter() {
	const { t, locale } = useI18n();

	const currentLocale = locale || 'en';

	const getFooterItemsForLocale = (items = []) => {
		if (!Array.isArray(items)) {
			return [];
		}

		return items
			.filter((item) => {
				if (!item?.url) {
					return false;
				}

				const translatedTitleKeys = Object.keys(item).filter((key) => {
					return key.endsWith('_title');
				});

				if (currentLocale === 'en') {
					return !!item.title && translatedTitleKeys.length === 0;
				}

				return !!item[`${currentLocale}_title`];
			})
			.map((item) => {
				if (currentLocale === 'en') {
					return item;
				}

				return {
					...item,
					title: item[`${currentLocale}_title`],
				};
			});
	};

	const footerMenuItems = getFooterItemsForLocale(FOOTER_MENU_ITEMS);
	const secondaryFooterMenuItems = getFooterItemsForLocale(FOOTER_MENU_ITEMS_SECONDARY);

	const renderFooterLink = (item, key) => {
		const isExternal = item?.target === '_blank';

		return (
			<a
				className="is-uppercase is-underlined mr-5 is-full"
				key={key}
				href={item.url}
				target={item?.target || undefined}
				rel={isExternal ? 'noopener noreferrer' : undefined}
			>
				{item.title}
			</a>
		);
	};

	return (
		<footer className={`${style.component} footer split-footer`}>
			<div className={`${style.container} footer-container`}>
				<div>
					<div className="logo has-text-centered">
						<img
							className={style.logo}
							src={CDN_URL + '/logo-footer.webp'}
							alt="White text Prospectus plus logo"
							width={147}
						/>
					</div>

					{secondaryFooterMenuItems.length > 0 && (
						<div className={`${style.menu} footer-menu menu-left is-flex is-justify-content-center`}>
							{secondaryFooterMenuItems.map(renderFooterLink)}
						</div>
					)}

					{FOOTER_ADDRESS && (
						<address
							className={`${style.address} address`}
							dangerouslySetInnerHTML={{ __html: FOOTER_ADDRESS }}
						/>
					)}
				</div>

				<div>
					<div className="content">
						<p className="is-uppercase is-size-6">
							{t('general.powered_by', LABEL_POWERED_BY)}{' '}
							<a
								target="_blank"
								rel="noreferrer"
								href="https://prospectus.plus"
								title="Visit the Prospectus Plus website"
							>
								Prospectus Plus
							</a>
						</p>
					</div>

					{footerMenuItems.length > 0 && (
						<div className={`${style.menu} footer-menu menu-right is-flex is-justify-content-center`}>
							{footerMenuItems.map(renderFooterLink)}
						</div>
					)}
				</div>
			</div>
		</footer>
	);
}
